module.exports = __webpack_public_path__ + "media/images/new-ui-images/iconizer-icon-light-blue-c0ae2e774cf0ca9dc433adf1ac7a193c.svg";